<template>
  <div class="panel flex">
    <div class="devideLine"></div>
    <div class="panelTop flex">
      <div class="topList">
        <div style="margin-right:.1rem">
          <img class="yuan" src="~images/index/home/pic_xxk.png" alt="" />
          <img class="ico" src="~images/index/home/cz.png" alt="" />
        </div>
        <div>
          <p>
            <span class="num">{{ qxcy }}</span> ({{ unit }})
          </p>
          <p>{{ qxcyN }}</p>
        </div>
      </div>
      <div class="topList">
        <div style="margin-right:.1rem">
          <img class="yuan" src="~images/index/home/pic_xxk.png" alt="" />
          <img class="ico" src="~images/index/home/cz.png" alt="" />
          <!-- <img class="ico" src="~images/index/home/kb.png" alt="" /> -->
        </div>
        <div>
          <p>
            <span class="num">{{ cyycy }}</span> ({{ unit }})
          </p>
          <p>{{ cyycyN }}</p>
        </div>
      </div>
    </div>
    <div class="panelCen flex">
      <p>{{ zdczN }}</p>
      <div class="zb1">
        <div class="zb2" :style="{ width: zdcz + '%' }">
          <img src="~images/index/home/linep.png" alt="" />
        </div>
      </div>
      <span style="color:#FFAE00;">{{ zdcz }}{{ zdczUnit }}</span>
    </div>
    <div class="panelBot flex">
      <div class="botLeft flex">
        <div class="flex">
          <p>
            <img src="~images/index/home/p1.png" alt="" />{{ dycyN
            }}<img
              :src="
                qndySt == 'ss'
                  ? require('images/index/home/ss.png')
                  : require('images/index/home/xj.png')
              "
            />较去年<span
              ><span v-if="qndySt == 'ss'">+</span
              ><span v-if="qndySt == 'xj'">-</span>{{ qndy }}%</span
            >
          </p>
          <p>
            <span class="num">{{ dycy }}</span
            >({{ unit }})
          </p>
        </div>
        <div class="flex">
          <p>
            <img src="~images/index/home/p2.png" alt="" />{{ decyN
            }}<img
              :src="
                qndeSt == 'ss'
                  ? require('images/index/home/ss.png')
                  : require('images/index/home/xj.png')
              "
            />较去年<span
              ><span v-if="qndeSt == 'ss'">+</span
              ><span v-if="qndeSt == 'xj'">-</span>{{ qnde }}%</span
            >
          </p>
          <p>
            <span class="num">{{ decy }}</span
            >({{ unit }})
          </p>
        </div>
        <div class="flex">
          <p>
            <img src="~images/index/home/p3.png" alt="" />{{ dscyN
            }}<img
              :src="
                qndsSt == 'ss'
                  ? require('images/index/home/ss.png')
                  : require('images/index/home/xj.png')
              "
            />较去年<span
              ><span v-if="qndsSt == 'ss'">+</span
              ><span v-if="qndsSt == 'xj'">-</span>{{ qnds }}%</span
            >
          </p>
          <p>
            <span class="num">{{ dscy }}</span
            >({{ unit }})
          </p>
        </div>
      </div>
      <div class="chart" ref="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadYqChart } from "../charts/yqCharts";
import { getScreenV2DataProcessGetCyycz } from "@/api/home";
export default {
  data() {
    return {
      zdcz: null, //主导产值占比值
      zdczUnit: null, //主导产值占比单位
      zdczN: null, //主导产值占比名字
      dycy: null,
      dycyN: "",
      decy: null,
      decyN: "",
      dscy: null,
      dscyN: "",
      qxcy: null,
      qxcyN: "",
      cyycy: null,
      cyycyN: "",
      ynsr: null,
      xnsr: null,
      bfb: null,
      chart: null,
      qndy: null, //较去年第一产值
      qndySt: null, //较去年第一状态
      qnde: null, //较去年第二产值
      qndeSt: null, //较去年第二状态
      qnds: null, //较去年第三产值
      qndsSt: null, //较去年第三状态
      unit: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let zczChart = this.$echarts.init(this.$refs.chart);
      getScreenV2DataProcessGetCyycz({ year: 2021 }).then(res => {
        /* const res = {
        data: [
          {
            name: "总产值",
            code: "qx",
            value: "541000",
            unit: "万元",
            status: ""
          },
          {
            name: "主导产值",
            code: "zd",
            value: "288000",
            unit: "万元",
            status: ""
          },
          {
            name: "主导产值占比",
            code: "zdzb",
            value: "26",
            unit: "%",
            status: ""
          },
          {
            name: "产业园一产值",
            code: "cyyzcz1",
            value: "122000",
            unit: "万元",
            status: ""
          },
          {
            name: "产业园二产值",
            code: "cyyzcz2",
            value: "105000",
            unit: "万元",
            status: ""
          },
          {
            name: "产业园三产值",
            code: "cyyzcz3",
            value: "61000",
            unit: "万元",
            status: ""
          },
          {
            name: "产业园一较去年",
            code: "cyyzczb1",
            value: "20",
            unit: "%",
            status: "ss"
          },
          {
            name: "产业园二较去年",
            code: "cyyzczb2",
            value: "20",
            unit: "%",
            status: "ss"
          },
          {
            name: "产业园三较去年",
            code: "cyyzczb3",
            value: "20",
            unit: "%",
            status: "xj"
          }
        ]
      }; */
        let datas = res.data;
        this.unit = datas[0].unit;
        this.qxcy = datas[0].value;
        this.qxcyN = datas[0].name;
        this.cyycy = datas[1].value;
        this.cyycyN = datas[1].name;
        this.zdcz = datas[2].value;
        this.zdczN = datas[2].name;
        this.zdczUnit = datas[2].unit;
        this.dycy = datas[3].value;
        this.dycyN = datas[3].name;
        this.decy = datas[4].value;
        this.decyN = datas[4].name;
        this.dscy = datas[5].value;
        this.dscyN = datas[5].name;
        this.qndy = datas[6].value;
        this.qndySt = datas[6].status;
        this.qnde = datas[7].value;
        this.qndeSt = datas[7].status;
        this.qnds = datas[8].value;
        this.qndsSt = datas[8].status;
        loadYqChart(
          zczChart,
          this.dycyN,
          this.decyN,
          this.dscyN,
          this.dycy,
          this.decy,
          this.dscy
        );
      });
      window.addEventListener("resize", () => {
        zczChart.resize();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 50%
  justify-content space-between
  flex-direction column

.devideLine
  height 2px
  width 100%
  background linear-gradient(to right, transparent, #0B305C, #155782, #0B305C, transparent)

.panelTop
  height 20%
  width 90%
  .topList
    display flex
    justify-content center
    align-items center
    width 50%
    div
      height 100%
      position relative
      p:nth-child(1)
        color #00FEDD
        font-size .06rem
        span
          font-size .15rem
    .yuan
      height 100%
      animation ro 5s linear infinite
    .ico
      position absolute
      top 50%
      left 50%
      transform translate(-50%,-50%)

@keyframes ro
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)

.panelCen
  align-items center
  height 10%
  width 90%
  margin 0 auto
  justify-content center
  span
    font-size .08rem
  .zb1
    width 60%
    height .06rem
    background rgb(1,44,67)
    border-top-right-radius .04rem
    border-bottom-right-radius .04rem
    margin 0 .05rem

  .zb2
    height 100%
    background #F3910A
    border-top-right-radius .04rem
    border-bottom-right-radius .04rem
    position relative
    overflow hidden
    img
      position absolute
      top 0
      height 100%
      left 0
      animation lin 3s linear infinite
@keyframes lin
  0%
    left -100%
  100%
    left 100%
.panelBot
  height 60%
  width 90%
  margin 0 auto
.botLeft
  flex-direction column
  justify-content space-between
  width 60%
  height 100%
  div
    width 100%
    height 33%
    flex-direction column
    align-items center
    justify-content center

    p
      text-align left
      width 100%
      display flex
      align-items center
      font-size .06rem

    img
      margin 0 .05rem

    p:nth-child(2)
      font-size .06rem
      color #00FEDD
      padding-left .2rem
      box-sizing border-box
      span
        font-size .1rem

.chart
  width 40%
  height 100%
</style>
